<div class="ditem">
  <div class="container-fluid body-color">

    <div class="my-3">
      <span class="nameofform">Register</span>
    </div>



    <div class="loginContent pt-3">
      <div class="Container-fluid px-5">

        <div class="row">
          <div class="col-lg-12">
            <div class="wrapper-progressBar">
              <ul class="progressBar">
                <li class="step0"><b>Plan Selection</b></li>
                <li class="active"><b>Organisation Information</b></li>
                <li class="step3"><b>Verification</b></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="requiredfield pt-5 pb-3">
          <b>**Fields marked with (<span class="required"></span>) are required</b>
        </div>
        <div class="alert alert-danger alert-dismissible fade show" role="alert" *ngIf="error_exist">
          <strong>Error!</strong>{{error_message}}
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form #onboardingForm="ngForm" class="needs-validation" novalidate>
          <div class="form-row">
            <div class="col-md-6">
              <label for="OrganisationID">Organisation ID</label>
              <input type="email" name="OrganisationID" class="form-control" id="OrganisationID" placeholder=""
                readonly>

              <!-- <div class="valid-feedback">
                      Looks good!
                    </div> -->
            </div>
            <!-- <div class="col-md-6 mb-3">
                    <label for="validationServer02">Last name</label>
                    <input type="text" class="form-control is-valid" id="validationServer02" value="Otto" required>
                    <div class="valid-feedback">
                      Looks good!
                    </div>
                  </div> -->
          </div>
          <div class="form-row">
            <div class="col-md-6">
              <label for="OrganisationName">Organisation Name<span class="required"></span></label>
              <input type="text" name="OrganisationName" class="form-control" id="OrganisationName"
                [(ngModel)]="userService.onboarding.organizationName" placeholder="Add Your Company Name" required>
              <div class="invalid-feedback">
                Please Provide valid Name
              </div>
            </div>
            <div class="col-md-6">
              <label for="RegistrationNumber">Registration Number <span class="required"></span></label>
              <input type="text" name="RegistrationNumber" class="form-control is-invalid" id="RegistrationNumber"
                [(ngModel)]="userService.onboarding.registrationNumber"
                placeholder="Add Your Company Registration Number" required>
              <!-- <div class="valid-feedback">
                      Looks good!
                    </div> -->
              <div class="invalid-feedback">
                Please Provide valid Registration Number
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6">
              <label for="addressLine1">Address Line 1<span class="required"></span></label>
              <input type="text" name="addressLine1" class="form-control is-invalid"
                [(ngModel)]="userService.onboarding.addressLine1" id="addressLine1"
                placeholder="Add Your Company Address Line1" required>
              <div class="invalid-feedback">
                Please Provide valid Line 1
              </div>
            </div>
            <div class="col-md-6">
              <label for="addressLine2">Address Line 2</label>
              <input type="text" name="addressLine2" class="form-control is-invalid" id="addressLine2"
                [(ngModel)]="userService.onboarding.addressLine2" placeholder="Add Your Company Address Line2 ">
              <!-- <div class="valid-feedback">
                      valid Address.
                    </div> -->

            </div>
          </div>
          <div class="form-row">
            <div class="col-md-3">
              <label for="validationCustom05">ZIP Code <span class="required"></span></label>
              <input type="text" name="zipCode" class="form-control is-invalid" id="validationCustom05"
                [(ngModel)]="userService.onboarding.zipCode" placeholder="Zip Code" required>
              <div class="invalid-feedback">
                Please provide a valid Zip code.
              </div>
            </div>
            <div class="col-md-3">
              <label for="countryId">Country<span class="required"></span></label>
              <select id="countryId" name="countryId" [(ngModel)]="userService.onboarding.countryId"
                class="form-control is-invalid" required>
                <option [value]="null" selected>Choose...</option>
                <option [value]="1">India</option>
                <option [value]="2">Bangladesh</option>
                <option [value]="3">Cuba</option>
                <option [value]="4">Russia</option>
                <option [value]="5">Singapore</option>
              </select>
              <div class="invalid-feedback">
                Please select a valid Country.
              </div>
            </div>
            <div class="col-md-3">
              <label for="noOfEmployees">Number Of Employees<span class="required"></span></label>
              <select id="noOfEmployees" name="noOfEmployees" [(ngModel)]="userService.onboarding.noOfEmployees"
                class="form-control is-invalid" required>
                <option [value]="null" selected>Choose...</option>
                <option [value]="10">1-10</option>
                <option [value]="200">51-200</option>
                <option [value]="1000">201-1000</option>
              </select>
              <div class="invalid-feedback">
                Please select Employees.
              </div>
            </div>
            <div class="col-md-3">
              <label for="noOfLicensesReq">Number Of Licences Required <span class="required"></span></label>
              <select id="noOfLicensesReq" name="noOfLicensesReq" [(ngModel)]="userService.onboarding.noOfLicensesReq"
                class="form-control is-invalid" required>
                <option [value]="null" selected>Choose...</option>
                <option [value]="1">1</option>

                <option [value]="2">2</option>
                <option [value]="3">3</option>
              </select>
              <div class="invalid-feedback">
                Please select a number.
              </div>
            </div>
          </div>


          <!-- </form>
              <form> -->
          <div class="form-row">
            <div class="col-md-6">
              <label for="orgWebsite">Website <span class="required"></span> </label>
              <input type="text" name="orgWebsite" class="form-control is-invalid" id="orgWebsite"
                [(ngModel)]="userService.onboarding.orgWebsite" placeholder="Add Your Website Address" required>
              <div class="invalid-feedback">
                Please provide a valid web address.
              </div>
            </div>
            <div class="form-group col-md-6">
              <label for="inputEmail4">Company Logo</label>
              <div class="custom-file">
                <input type="file" name="companyLogo" (change)="handleFileInput($event.target.files)"
                  class="custom-file-input" id="companyLogo">
                <label class="custom-file-label" id="companyLogoLabel" for="validatedCustomFile">Choose file...</label>
                <div class="invalid-feedback">Example invalid custom file feedback</div>
              </div>
            </div>


          </div>
          <div class="form-row">
            <div class="col-md-6">
              <label for="firstName">First Name(For Admin) <span class="required"></span></label>
              <input type="text" name="firstName" class="form-control is-invalid" id="firstName"
                value="Add your first name" [(ngModel)]="userService.onboarding.firstName" required>
              <div class="invalid-feedback">
                Please provide a valid First Name.
              </div>
            </div>
            <div class="col-md-6">
              <label for="lastName">Last Name(For Admin) <span class="required"></span></label>
              <input name="lastName" type="text" class="form-control is-invalid" id="lastName"
                value="Add your last name" [(ngModel)]="userService.onboarding.lastName" required>
              <div class="invalid-feedback">
                Please provide a valid Last Name.
              </div>
            </div>

          </div>
          <div class="form-row">
            <div class="col-md-6">
              <label for="officialEMail">Official Email Address <span class="required"></span></label>
              <input type="email" name="officialEMail" class="form-control is-invalid" id="officialEMail"
                [(ngModel)]="userService.onboarding.officialEMail" placeholder="Add your Company Email Address"
                required>
              <div class="invalid-feedback">
                Please provide a valid Email.
              </div>

            </div>
            <div class="col-md-6">
              <label for="contactNumber">Contact Number<span class="required"></span></label>
              <input type="number" name="contactNumber" class="form-control is-invalid" id="contactNumber"
                [(ngModel)]="userService.onboarding.contactNumber" placeholder="Add Your Contact Number" required>
              <div class="invalid-feedback">
                Please provide a valid contact number.
              </div>
            </div>

          </div>

        </form>
        <!-- <br> -->
        <hr>
        <div class="form-group">
          <div class="form-check">
            <!-- <input class="form-check-input is-invalid" [checked]="parentcheckbox" type="checkbox" (change)="onCheckboxChange($event)" value="" id="" required>
                  <label class="form-check-label" for="">
                    I have read and agree to all the terms and conditions below (check all Boxes)
                  </label> -->
            <!-- <br> -->
            <!-- <input class="form-check-input is-invalid ml-4" type="checkbox" value="" id="invalidCheck3" required>
                  <label class="form-check-label ml-5" for="invalidCheck3">
                  I have read and agree to the<a href="#"> Enterprise Agreement.</a>
                  </label> -->
            <!-- <br> -->
            <input class="form-check-input is-invalid ml-2" type="checkbox" [checked]="childcheckbox" id="" required>
            <label class="form-check-label ml-4" for="">
              I have read and agree to the <a href="#">Sundeus Online Service Agreement.</a>
            </label>
            <br>
            <!-- <input class="form-check-input is-invalid ml-4" type="checkbox" value="" id="invalidCheck3" required>
                  <label class="form-check-label ml-5" for="invalidCheck3">
                    I have read and agree to the <a href="#">Developer Program terms & Condition.</a>
                  </label> -->
            <!-- <div class="invalid-feedback">
                    You must agree before submitting.
                  </div> -->
          </div>
        </div>
        <div #loaderRef id="loader" style="display: none;"></div>
        <button class="btn btn-primary my-3" type="submit" (click)="submit(onboardingForm)"
        >Submit for
          Verification</button>
        <!-- <a href="https://www.sundeus.com/contractMagmt.html#Sectionplans"
          class="stretched-link-custom">&nbsp;&nbsp;&lt;&lt; <b>Go to Plans & Pricing</b></a> -->

      </div>
    </div>

  </div>
</div>